import { supabase } from '../../shared/supabase/supabaseClient';
import type { GastronomyStockMode } from './gastronomyStockMode';

export async function applyGastronomyStockMode(
  mode: GastronomyStockMode,
  options?: { applyPack?: boolean },
): Promise<void> {
  const { error } = await supabase.rpc('apply_gastronomy_stock_mode', {
    p_mode: mode,
    p_apply_pack: options?.applyPack ?? true,
  });
  if (error) throw error;
}
